import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaHeadset } from "react-icons/fa6";
import ITSupport from "./index";
import ViewTicketDetail from "./view";

const itSupportRoutes = [	
    generateCRUDRoutes({
        mainTitle: "IT Support",
        basePath: "support",
        mainComponent: <ITSupport />,
        layout: "/console",	   
        icon: <FaHeadset className="icon-item" />,
        viewComponent: <ViewTicketDetail />,
        subTitle:"IT Support",
        level:5,
        moduleId: 0,
    })
]

export default itSupportRoutes;